import { Component, createRef } from "react";
import { NSBoxEnum, NSBoxEntity, NSBoxEmail, NSBoxPhone, NSColumn, NSRow } from 'namirasoft-site-react';
import { NSARouterMakerProps } from "namirasoft-account-react";
import { NSBoxString, NSBoxTextArea } from "namirasoft-site-react";
import { SubscriberRow, SubscriberInputRow, SubscriberSenderType, TopicRow } from "namirasoft-notification-sender";
import { ProviderRow as SMSProviderRow } from "namirasoft-sms-sender";
import { ProviderRow as EmailProviderRow } from "namirasoft-email-sender";
import { ProviderRow as SlackProviderRow } from "namirasoft-slack-sender";
import { ProviderRow as TelegramProviderRow } from "namirasoft-telegram-sender";
import { NotificationSenderProps } from "../NotificationSenderProps";
import { NotificationSenderLayout } from "../NotificationSenderLayout";
import { NotificationSenderEntity } from "../NotificationSenderEntity";
import { SortItem } from "namirasoft-core";
import { NamirasoftMap } from "namirasoft-site-map";

export interface SubscriberEditPageProps extends NSARouterMakerProps, NotificationSenderProps
{
	isEdit: boolean;
}

interface SubscriberEditPageState
{
	sender_type: string;
}

class SubscriberEditPage extends Component<SubscriberEditPageProps, SubscriberEditPageState>
{
	private NSBoxString_Name = createRef<NSBoxString>();
	private NSBoxEntity_Topic = createRef<NSBoxEntity<TopicRow>>();
	private NSBoxEnum_Sender_Type = createRef<NSBoxEnum<SubscriberSenderType>>();
	private NSBoxEntity_SMS = createRef<NSBoxEntity<SMSProviderRow>>();
	private NSBoxEntity_Email = createRef<NSBoxEntity<EmailProviderRow>>();
	private NSBoxEntity_Telegram = createRef<NSBoxEntity<TelegramProviderRow>>();
	private NSBoxEntity_Slack = createRef<NSBoxEntity<SlackProviderRow>>();
	private NSBoxString_Sender_Email = createRef<NSBoxEmail>();
	private NSBoxString_Sender_SMS = createRef<NSBoxPhone>();
	private NSBoxString_Sender_Telegram_ChatID = createRef<NSBoxString>();
	private NSBoxString_Sender_Telegram_MessageThreadID = createRef<NSBoxString>();
	private NSBoxString_Sender_Slack_Channel = createRef<NSBoxString>();

	private NSBoxTextArea_Description = createRef<NSBoxTextArea>();

	constructor(props: SubscriberEditPageProps)
	{
		super(props);
		this.state = { sender_type: "" };
	}
	override render()
	{
		let sender_text = "";
		switch (this.state.sender_type)
		{
			case SubscriberSenderType.Email:
				sender_text = "Email Address";
				break;
			case SubscriberSenderType.SMS:
				sender_text = "Phone Number";
				break;
			case SubscriberSenderType.Telegram:
				sender_text = "Chat ID";
				break;
		}

		let style_email: React.CSSProperties = {};
		let style_slack: React.CSSProperties = {};
		let style_sms: React.CSSProperties = {};
		let style_telegram: React.CSSProperties = {};
		if (this.state.sender_type !== SubscriberSenderType.Email)
			style_email.display = "none";
		if (this.state.sender_type !== SubscriberSenderType.Slack)
			style_slack.display = "none";
		if (this.state.sender_type !== SubscriberSenderType.SMS)
			style_sms.display = "none";
		if (this.state.sender_type !== SubscriberSenderType.Telegram)
			style_telegram.display = "none";

		let namirasoft = new NamirasoftMap(this.props.account.token_manager, console.error);

		return (
			<>
				<NotificationSenderLayout<SubscriberRow, SubscriberInputRow>
					{...this.props}
					pages={{
						entity: NotificationSenderEntity.Subscriber(this.props),
						edit: {
							...this.props,
							ui: {
								tab_page_edit: {
									editor: {
										getInputRow: () =>
										{
											let name: string = this.NSBoxString_Name.current?.getValue() ?? "";
											let topic_id: string = this.NSBoxEntity_Topic.current?.getValueOne() ?? "";
											let sender_type: SubscriberSenderType = this.NSBoxEnum_Sender_Type.current?.getValueEnumOne(SubscriberSenderType, SubscriberSenderType.Email) ?? SubscriberSenderType.Email;
											let sender_id: string = "";
											let value: string = "";
											if (sender_type === SubscriberSenderType.Email)
											{
												sender_id = this.NSBoxEntity_Email.current?.getValueOne() ?? "";
												value = this.NSBoxString_Sender_Email.current?.getValue() ?? "";
											}
											else if (sender_type === SubscriberSenderType.Slack)
											{
												sender_id = this.NSBoxEntity_Slack.current?.getValueOne() ?? "";
												value = this.NSBoxString_Sender_Slack_Channel.current?.getValue() ?? "";
											}
											else if (sender_type === SubscriberSenderType.SMS)
											{
												sender_id = this.NSBoxEntity_SMS.current?.getValueOne() ?? "";
												value = this.NSBoxString_Sender_SMS.current?.getValue() ?? "";
											}
											else if (sender_type === SubscriberSenderType.Telegram)
											{
												sender_id = this.NSBoxEntity_Telegram.current?.getValueOne() ?? "";
												let chat_id = this.NSBoxString_Sender_Telegram_ChatID.current?.getValue() ?? "";
												let message_thread_id = this.NSBoxString_Sender_Telegram_MessageThreadID.current?.getValue() ?? "";
												value = [chat_id, message_thread_id].join(";");
											}
											let description: string = this.NSBoxTextArea_Description.current?.getValue() ?? "";

											return {
												name,
												workspace_id: "",
												topic_id,
												sender_id,
												sender_type,
												value,
												description,
												subscriber_category: [], subscriber_field: [], subscriber_tag: []
											};
										},
										setRow: (row) =>
										{
											this.NSBoxString_Name.current?.setValue(row.name);
											this.NSBoxEntity_Topic.current?.setValue(row.topic_id);
											this.NSBoxEnum_Sender_Type.current?.setValue(row.sender_type, () =>
											{
												if (row.sender_type === SubscriberSenderType.Email)
												{
													this.NSBoxEntity_Email.current?.setValue(row.sender_id);
													this.NSBoxString_Sender_Email.current?.setValue(row.value);
												}
												else if (row.sender_type === SubscriberSenderType.Slack)
												{
													this.NSBoxEntity_Slack.current?.setValue(row.sender_id);
													this.NSBoxString_Sender_Slack_Channel.current?.setValue(row.value);
												}
												else if (row.sender_type === SubscriberSenderType.SMS)
												{
													this.NSBoxEntity_SMS.current?.setValue(row.sender_id);
													this.NSBoxString_Sender_SMS.current?.setValue(row.value);
												}
												else if (row.sender_type === SubscriberSenderType.Telegram)
												{
													this.NSBoxEntity_Telegram.current?.setValue(row.sender_id);
													let values = row.value.split(",");
													this.NSBoxString_Sender_Telegram_ChatID.current?.setValue(values[0]);
													this.NSBoxString_Sender_Telegram_MessageThreadID.current?.setValue(values[1]);
												}
												this.NSBoxTextArea_Description.current?.setValue(row.description ?? "");
											});
										}
									}
								}
							},
						}
					}}
				>
					<NSColumn>
						<NSRow>
							<NSBoxString
								ref={this.NSBoxString_Name}
								title="Name"
								required
								style={{ width: "100%" }}
							/>
						</NSRow>
						<NSRow>
							<NSBoxEntity<TopicRow>
								ref={this.NSBoxEntity_Topic}
								title="Topic"
								required
								multiple={false}
								table={namirasoft.notification_sender.tables.topic}
								getValue={item => item.id}
								getTitle={item => item.name}
								getSort={() =>
								{
									let namirasoft = new NamirasoftMap();

									let table = namirasoft.notification_sender.tables.topic;
									let column = table.columns.name;
									return new SortItem(table, column, true);
								}}
							/>
							<NSBoxEnum
								ref={this.NSBoxEnum_Sender_Type}
								title="Sender Type"
								required
								multiple={false}
								getEnumObject={() => SubscriberSenderType}
								onChanged={() =>
								{
									let sender_type = this.NSBoxEnum_Sender_Type.current?.getValueEnumOne(SubscriberSenderType, SubscriberSenderType.Email) ?? "";
									this.setState(prevState => { return { ...prevState, sender_type, sender_text } })
								}}
							/>
						</NSRow>
						{
							<NSRow
								style={style_email}
							>
								<NSBoxEntity<EmailProviderRow>
									ref={this.NSBoxEntity_Email}
									title="Email Sender"
									required
									multiple={false}
									table={namirasoft.email_sender.tables.provider}
									getValue={item => item.id}
									getTitle={item => item.name}
									getSort={() =>
									{
										let namirasoft = new NamirasoftMap();

										let table = namirasoft.email_sender.tables.provider;
										let column = table.columns.name;
										return new SortItem(table, column, true);
									}}
								/>
								<NSBoxEmail ref={this.NSBoxString_Sender_Email} title="Email Address" placeholder={`Enter your email address`} required />
							</NSRow>
						}
						{
							<>
								<NSRow
									style={{ ...style_slack }}
								>
									<NSBoxEntity<SlackProviderRow>
										ref={this.NSBoxEntity_Slack}
										title="Slack Sender"
										required
										multiple={false}
										table={namirasoft.slack_sender.tables.provider}
										getValue={item => item.id}
										getTitle={item => item.name}
										getSort={() =>
										{
											let namirasoft = new NamirasoftMap();

											let table = namirasoft.slack_sender.tables.provider;
											let column = table.columns.name;
											return new SortItem(table, column, true);
										}}
									/>
									<NSBoxString
										ref={this.NSBoxString_Sender_Slack_Channel}
										title="Channel"
										required={false} />
								</NSRow>
							</>
						}
						{
							<NSRow
								style={style_sms}
							>
								<NSBoxEntity<SMSProviderRow>
									ref={this.NSBoxEntity_SMS}
									title="SMS Sender"
									required
									multiple={false}
									table={namirasoft.sms_sender.tables.provider}
									getValue={item => item.id}
									getTitle={item => item.name}
									getSort={() =>
									{
										let namirasoft = new NamirasoftMap();

										let table = namirasoft.sms_sender.tables.provider;
										let column = table.columns.name;
										return new SortItem(table, column, true);
									}}
								/>
								<NSBoxPhone
									ref={this.NSBoxString_Sender_SMS}
									title="Phone Number"
									required />
							</NSRow>
						}
						{
							<>
								<NSRow
									style={{ ...style_telegram }}
								>
									<NSBoxEntity<TelegramProviderRow>
										ref={this.NSBoxEntity_Telegram}
										title="Telegram Sender"
										required
										multiple={false}
										table={namirasoft.telegram_sender.tables.provider}
										getValue={item => item.id}
										getTitle={item => item.name}
										getSort={() =>
										{
											let namirasoft = new NamirasoftMap();

											let table = namirasoft.telegram_sender.tables.provider;
											let column = table.columns.name;
											return new SortItem(table, column, true);
										}}
										style={{ width: "100%" }}
									/>
								</NSRow>

								<NSRow
									style={style_telegram}
								>
									<NSBoxString
										ref={this.NSBoxString_Sender_Telegram_ChatID}
										title="Chat ID"
										required={false} />
									<NSBoxString
										ref={this.NSBoxString_Sender_Telegram_MessageThreadID}
										title="Message Thread ID"
										required={false} />
								</NSRow>
							</>
						}
						<NSBoxTextArea
							ref={this.NSBoxTextArea_Description}
							required={false}
							title="Description"
							rows={5}
							style={{ width: "100%" }}
						/>
					</NSColumn>
				</NotificationSenderLayout>
			</>
		);
	}
}

export default SubscriberEditPage;